import React from "react";
import "./src/styles/global.css";

import { ContextProvider } from "./src/context/Context";

export const wrapRootElement = ({ element }) => (
	<ContextProvider>{element}</ContextProvider>
);

export const onRouteUpdate = () => {
	if (typeof window !== "undefined" && window.ScrollTrigger) {
		// Small delay ensures DOM is fully painted
		setTimeout(() => {
			window.ScrollTrigger.refresh();
		}, 100);
	}
};
